/* Automatically generated file, do not update manually */
import type { Provider } from '@ethersproject/abstract-provider';
import { Contract, Signer } from 'ethers';
import { useMemo } from 'react';

import abi from 'libs/contracts/generated/infos/abis/Vrt.json';
import { Vrt } from 'libs/contracts/generated/infos/contractTypes';
import { useProvider, useSigner } from 'libs/wallet';
import { ChainId } from 'types';

interface GetVrtContractInput {
  address: string;
  signerOrProvider: Signer | Provider;
}

export const getVrtContract = ({ signerOrProvider, address }: GetVrtContractInput) =>
  new Contract(address, abi, signerOrProvider) as Vrt;

interface UseGetVrtContractInput {
  passSigner: boolean;
  address: string;
  chainId?: ChainId;
}

export const useGetVrtContract = ({
  passSigner = false,
  address,
  chainId,
}: UseGetVrtContractInput) => {
  const { provider } = useProvider({ chainId });
  const { signer } = useSigner({ chainId });
  const signerOrProvider = passSigner ? signer : provider;

  return useMemo(
    () =>
      signerOrProvider
        ? getVrtContract({
            address,
            signerOrProvider,
          })
        : undefined,
    [signerOrProvider, address],
  );
};
